
import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';
import { errorService } from './errorService';

export const ORGANIZATION_API_KEY = process.env.REACT_APP_ORGANIZATION_API_KEY;

export const commerceApi = axios.create({
  baseURL: process.env.REACT_APP_COMMERCE_API_URL,
  headers: 
  { 
    "Content-Type": "application/json",
    "X-Organisation-API-Key": ORGANIZATION_API_KEY,
    "Accept-Language": "sr-Latn"
  },
});

// --- Interceptors ---

// Generic handler for API calls
const handleRequest = async <T>(api: AxiosInstance, config: AxiosRequestConfig): Promise<T> => {
  try {
    const response: AxiosResponse<T> = await api.request(config);

    return response.data;
  } catch (error: unknown) {
    // Error is already handled by interceptor, don't re-throw to avoid double error handling
    // Just return a rejected promise without additional processing
    return Promise.reject(error);
  }
};

// Helper functions for each API
const createApiHelpers = (api: AxiosInstance) => ({
  get: async <T>(url: string, params?: object) => {
    return handleRequest<T>(api, { method: 'GET', url, params, baseURL: api.defaults.baseURL });
  },

  post: <T>(url: string, data?: object) =>
    handleRequest<T>(api, { method: 'POST', url, data, baseURL: api.defaults.baseURL }),

  put: <T>(url: string, data?: object) =>
    handleRequest<T>(api, { method: 'PUT', url, data, baseURL: api.defaults.baseURL }),

  patch: <T>(url: string, data?: object) =>
    handleRequest<T>(api, { method: 'PATCH', url, data, baseURL: api.defaults.baseURL }),

  delete: <T>(url: string) =>
    handleRequest<T>(api, { method: 'DELETE', url, baseURL: api.defaults.baseURL }),
});

// Export API helpers
export const commerceApiClient = createApiHelpers(commerceApi);

export const updateCommerceApiUrl = (newBaseUrl: string) => {
  commerceApi.defaults.baseURL = newBaseUrl;
};

// Export the error service for direct use in components
export { errorService };
